import { useCallback, useEffect, useRef } from "react";
import { useFormikContext } from "formik";
import * as Yup from "yup";
import { Paper, Stack, TextField, Typography } from "@mui/material";
// import GoogleMapReact from "google-map-react";
import pick from "lodash/pick";
import { v4 } from "uuid";
import { useAppSelector, useUserProfile } from "@/hooks";
import { RootState } from "@/store/store";
// import useOrganizations from "@/features/organizations/useOrganizations";
import { CheckoutSharedProps } from "@/pages/checkout/CheckoutPage";
import { LocalStorage } from "@/constants/localStorage";
import { DeliveryLocation, Location as ILocation } from "@/types/user";
// import NeighborhoodAutocomplete from "@/components/NeighborhoodAutocomplete";
// import { openLocationDialog } from "@/store/uiSlice";

export const LocationFormSchema = Yup.object().shape({
  // neighborhood: Yup.string(),
  house: Yup.string(),
  address: Yup.string().required("Es necesario indicar la dirección, por ejemplo: Altamira, de la Vicky 1 cuadra al lago, 25 varas arriba, casa color amarillo"),
});

export type ILocationForm = DeliveryLocation;

export const locationFormInitialValues: ILocationForm = {
  id: "",
  // neighborhood: "",
  address: "",
  house: "",
  distance: null,
  duration: null,
};

export const locationFormFields = Object.keys(locationFormInitialValues);

export const onSubmitLocationForm = async (values: ILocationForm, sharedProps: CheckoutSharedProps) => {
  const { activeUser } = sharedProps;
  const draft = pick(values, locationFormFields);

  if (!draft?.id) draft.id = v4();

  if (activeUser?.isAnonymous) {
    const ls = localStorage.getItem(LocalStorage.USER);
    const lsUser = JSON.parse(ls ?? "{}");
    const updatedUser = JSON.stringify({ ...lsUser, location: pick(values, locationFormFields) });
    localStorage.setItem(LocalStorage.USER, updatedUser);
  }
};

const LocationForm = () => {
  // const dispatch = useAppDispatch();
  const { activeUser } = useUserProfile();
  // const { currentOrganization } = useOrganizations();
  const order = useAppSelector((state: RootState) => state.order);
  const formik = useFormikContext<ILocationForm>();

  const mapRef = useRef<any>(null);
  const mapsRef = useRef<any>(null);
  const markerRef = useRef<any>(null);

  // const INITIAL_LOCATION = {
  //   lat: formik.values?.latitude || order?.deliveryLocation?.latitude || currentOrganization?.latitude || 12.115,
  //   lng: formik.values?.longitude || order?.deliveryLocation?.longitude || currentOrganization?.longitude || -86.2362,
  // };

  // const loadMap = (map: any, maps: any) => {
  //   mapRef.current = map;
  //   mapsRef.current = maps;
  //   const position = INITIAL_LOCATION;

  //   const marker = new maps.Marker({
  //     position,
  //     map,
  //     draggable: false,
  //   });

  //   markerRef.current = marker;

  //   marker.addListener("dragend", async () => { });
  // };

  useEffect(() => {
    if (mapRef.current && markerRef.current && mapsRef.current) {
      const position = { lat: order?.deliveryLocation?.latitude, lng: order?.deliveryLocation?.longitude };
      markerRef.current.setPosition(position);
      mapRef.current.panTo(position);
    }
  }, [order?.deliveryLocation?.latitude, order?.deliveryLocation?.longitude]);

  const loadDeliveryLocation = useCallback(() => {
    let locations: ILocation[] = [];

    if (activeUser) {
      if (activeUser?.isAnonymous && activeUser?.location) {
        locations.push(activeUser.location);
      } else if (activeUser?.locations) {
        locations = [...activeUser.locations];
      }
    }

    if (!locations?.length) return;

    const selectedLocation = locations.find((l) => l.id === order.deliveryLocation?.id);

    if (selectedLocation) {
      formik.setValues({
        ...formik.values,
        ...selectedLocation,
      });
    } else {
      formik.setValues({
        ...formik.values,
        ...locations[0],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeUser, order.deliveryLocation]);

  useEffect(() => {
    loadDeliveryLocation();
  }, [loadDeliveryLocation]);

  return (
    <Stack spacing={2} flex={1}>
      <Typography>¿Dónde deseas que se entregue?</Typography>
      {/* <Stack style={{ width: "100%" }} flex={1} spacing={2}>
        <GoogleMapReact
          center={INITIAL_LOCATION}
          onGoogleApiLoaded={({ map, maps }) => loadMap(map, maps)}
          defaultZoom={12}
          bootstrapURLKeys={{
            key: import.meta.env.VITE_FIREBASE_API_KEY,
          }}
          yesIWantToUseGoogleMapApiInternals
          options={{
            zoomControl: true,
            mapTypeControl: true,
            fullscreenControl: false,
            mapTypeControlOptions: {
              style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
              position: google.maps.ControlPosition.TOP_LEFT,
            },
            zoomControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
            },
          }}
        />
        <Stack alignItems="center">
          <Button size="small" variant="outlined" onClick={() => dispatch(openLocationDialog())}>Editar Ubicación</Button>
        </Stack>
      </Stack> */}
      <Paper>
        <Stack padding={2} spacing={2}>
          {/* <NeighborhoodAutocomplete
            value={formik.values.neighborhood}
            error={!!formik.errors.neighborhood}
            helperText={formik.errors.neighborhood}
            fullWidth
            onChange={(value) => {
              formik.setFieldValue("neighborhood", value);
            }}
          /> */}

          <TextField
            name="address"
            label="Indicaciones para el repartidor"
            value={formik.values.address}
            error={Boolean(formik.errors.address)}
            onBlur={formik.handleBlur}
            helperText={formik.errors.address}
            multiline
            rows={6}
            onChange={formik.handleChange}
          />
        </Stack>
      </Paper>
    </Stack>
  );
};

export default LocationForm;
